import React, {useEffect} from 'react'
import {Link} from "react-router-dom"

const Privacy = (props) => {

  useEffect(() => {
    window.scrollTo(0,0)
  },[])

  return ( <>
  <div style={{ position: 'relative' }}>

    <audio controls src={`${process.env.PUBLIC_URL}/songs/Building the Dream - OurStorySong.mp3`}></audio>
    <br/>
    <a href={`${process.env.PUBLIC_URL}/Building the Dream - OurStorySong.mp3`} download>Download</a>

    <h2>Building the Dream</h2>

    <p>
        [Verse 1]<br/>
        Summers on a lake with family and friends<br/>
        A time when a season would just never end<br/>
        The ball games on the beach, the sun on his face<br/>
        As some folks played spud in that one special place<br/>
        Two brothers and their friends, a friendly competition<br/>
        They skied on the water with a shared ambition<br/>
        <br/>
        [Chorus]<br/>
        Oh, the days at the lake, they all ran together<br/>
        Four or five days feeling like a whole summer<br/>
        With families all coming and going in the sun<br/>
        A house with a yard where the work's never done<br/>
        It's a story they built, with their hands and their heart<br/>
        A beautiful home, a brand new start<br/>
        <br/>
        [Verse 2]<br/>
        The house in Garrett Park, a long, winding road<br/>
        Each room with its own story and its own heavy load<br/>
        A son was a month old, and the work began<br/>
        With friends and with family, he came up with a plan<br/>
        They tore down the walls and raised up the frames<br/>
        A puzzle with spaces, a place full of names<br/>
        <br/>
        [Chorus]<br/>
        Oh, the days at the lake, they all ran together<br/>
        Four or five days feeling like a whole summer<br/>
        With families all coming and going in the sun<br/>
        A house with a yard where the work's never done<br/>
        It's a story they built, with their hands and their heart<br/>
        A beautiful home, a brand new start<br/>
        <br/>
        [Bridge]<br/>
        From England to China, adventures they had<br/>
        And stories they'd tell, both the good and the bad<br/>
        Remember those kids, when they were small<br/>
        Scott climbing ladders, defying a fall<br/>
        And Katrina with matches, a spark in her hand<br/>
        A beautiful danger across the whole land<br/>
        <br/>
        [Outro]<br/>
        The house he built is now full of things<br/>
        Each one a memory, a story it brings<br/>
        A life lived with love, and with family and friends<br/>
        A story that's still being written, and never quite ends<br/>
    </p>

    </div>
  </> )
}

export default Privacy
